@if (isLoading) {
  <mds-loader [loadingText]="'Loading...'"></mds-loader>
}

@if (!isLoading) {
  <article class="epd-dashboard" id="epdDashboard">
    <app-epd-dashboard-header
      [productName]="productName"
      [standardLogo]="standardLogo"
      [selectedPcr]="selectedPcr"
      [dataUpdated]="data.updated"
      [selectedMethod]="selectedMethod"
      [methodList]="methodList"
      [pcrList]="pcrList"
      [languages]="languages"
      [selectedLanguage]="selectedLanguage"
      [canPreview]="!!canPreview"
      [previewButtonLabel]="previewButtonLabel"
      (methodologyChange)="onChangeMethodology($event)"
      (pcrChange)="onChangePcr($event)"
      (languageChange)="onChangeLanguage($event)"
      (preview)="previewAndExport()"
    ></app-epd-dashboard-header>

    @if (showEpdManagement) {
      <app-epd-management-card
        [data]="epdFamilyStatus"
        [statusFormSchema]="statusFormSchema"
        [resumeFormSchema]="resumeFormSchema"
        [hasFamily]="!!familyRid"
        [productRid]="rid"
        [familyRid]="familyRid"
        [selectedStandard]="selectedMethod"
        [selectedPcr]="selectedPcr"
      ></app-epd-management-card>
    }

    <app-epd-dashboard-content
      [chartsData]="chartsData"
      [highcharts]="Highcharts"
      [section]="section"
      [tableData]="tableData"
      [canPreview]="!!canPreview"
      [previewButtonLabel]="previewButtonLabel"
      (editSectionUpdated)="onEditSectionUpdated($event)"
      (preview)="previewAndExport()"
    ></app-epd-dashboard-content>
  </article>
}
